import myHeader from "../../components/header.vue"
import {
  getEntpCourseConfigCurrent,
  getUserCourseStudyDetail,
  addCustomerInformationInfo,
  getEnterpriseWebsite,
  getStudyccCountToday
} from '../../apiCloud/coursePlay'
import CameraDialog from "../../components/CameraDialog/CameraDialog.vue";
import {
  eUrl
} from "@/api/baseURL.js";
import PdfViewer from "../../components/PdfViewer";
import { saveAs } from 'file-saver';

let that

//检测电脑设备是否已经安装了摄像头
if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
  // Firefox 38+ seems having support of enumerateDevicesx
  navigator.enumerateDevices = function (callback) {
    navigator.mediaDevices.enumerateDevices().then(callback);
  };
}
var MediaDevices = [];
var isHTTPs = location.protocol === 'https:';
var canEnumerate = false;

if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
  canEnumerate = true;
} else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
  canEnumerate = true;
}

var hasMicrophone = false;
var hasSpeakers = false;
var hasWebcam = false;

var isMicrophoneAlreadyCaptured = false;
var isWebcamAlreadyCaptured = false;

export default {
  // components: {
  //   myHeader
  // },
  components: {
    CameraDialog,
    PdfViewer
  },
  data() {
    return {
      midTake: false, //课程中间是否拍过照
      takePhotoInter: "", //定时器
      isWatch: "", //定时器实时告诉浏览器有一个课再看
      // 看课拍照参数
      courseConfig: {
        camera: false,
        completeRateFlag: 90,
        canDrop: "on"
      },
      dialogTableVisible: false,
      djsTime: 0,
      imgUrl: "", // 拍摄的照片路径
      timeOut: null, // 拍照定时器
      takePhotoCount: 1, //定时拍照次数
      select: 'hh',
      player: null,
      playTime: 0,
      show: true,
      liSelected: '100',
      playHeight: '400',

      remove: false,
      current: -1,
      vid: '',
      ccId: '',
      start: 0,
      courseOver: '',
      packagebagId: '',
      courseId: '',
      empStudyId: '',
      courseName: '',
      intervalid1: null,
      interval: null,
      autoPlay: true,
      baseInfoCatalogList: [],
      empHeadportrait: '',
      coursePic: '',
      resouceHours: 0,
      isSave: false,
      playData: {},
      oldTokenId: '',
      oldPlayTime: 0,
      playObj: {},
      regId: "",
      resData: {},
      popupDialog: false,
      formData: {
        name: '',
        telephone: '',
        wxNumber: '',
        remark: ''
      },
      rules: {
        name: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }],
        telephone: [{
          required: true,
          message: "请输入手机号",
          trigger: "blur"
        }],
        // wxNumber: [{
        //   required: true,
        //   message: "请输入微信号",
        //   trigger: "blur"
        // }],
        // remark: [{
        //   required: true,
        //   message: "请输入备注",
        //   trigger: "blur"
        // }],
      },
      courseIdList: [],
      isDisabled: false,
      pdfLink:'',
      currentPage: 1,
      pageCount: 0,
      isPdf:false
    }
  },
  beforeCreated() {},
  created() {
    this.oldTokenId = localStorage.getItem("oldTokenId");
    if (JSON.parse(localStorage.getItem("playData"))) {
      this.playData = JSON.parse(localStorage.getItem("playData")); //课程详情页面进入播放页面存入的播放所需参数
      this.packagebagId = this.playData.packagebagId;
      this.pdfLink = this.playData.coursewareUrl
      this.regId = this.playData.regId;
      this.courseId = this.playData.courseId;
      if(this.playData.isPdf ==true){
        this.isPdf = true;
      }else{
        this.isPdf = false;
      }
    } else {
      this.packagebagId = '';
      this.regId = '';
      this.courseId = '';
    }

    this.empHeadportrait = localStorage.getItem("empHeadportrait"); //获取学员头像
    this.getCourseBaseInfoCatalog();
    that = this
  },
  mounted() {
    this.getConfig();
    this.isWatch = setInterval(function () {
      localStorage.setItem('isWatch', "yes")
      console.log("jianting")
    }, 1000)
    this.getScreenHeight()
  },
  beforeDestroy() {
    clearInterval(that.intervalid1);
    that.intervalid1 = null;
    clearInterval(that.interval);
    clearInterval(that.isWatch);
    that.interval = null;
    if(that.isPdf ==false) {
      /**保利威替换 start */
      // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
      /**保利威替换 end */
    }
    // window.j2s_stopVideo()
    // console.log("出去")
    localStorage.removeItem('video_on')
  },
  destroyed() {
    // console.log("出去2")
  },
  methods: {
    change() {
      this.$forceUpdate()
    },
    // 获取完整体验课程提交
    determineActivation(formName) {
      let data = {
        name: this.formData.name,
        telephone: this.formData.telephone,
        wxNumber: this.formData.wxNumber,
        remark: this.formData.remark,
        entpId: this.entpId,
        courseName: this.courseName
      }
      this.isDisabled = true
      setTimeout(() => {
        this.isDisabled = false //点击一次时隔两秒后才能再次点击
      }, 2000)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addCustomerInformationInfo(data).then(res => {
            if (res.code == 200) {
              this.$message({
                message: '若要获取完整体验课程，请等待工作人员联系您！',
                type: 'success'
              });
              this.popupDialog = false;
              sessionStorage.getItem('courseIds')
              if (sessionStorage.getItem('courseIds')) {
                console.log('sessionStorage', this.courseId, sessionStorage.getItem('courseIds'))
                this.courseIdList.push(this.courseId)
                this.courseIdList.push(sessionStorage.getItem('courseIds'))
                sessionStorage.setItem('courseIds', this.courseIdList)
              } else {
                sessionStorage.setItem('courseIds', this.courseId)
              }
              this.formData.name = ''
              this.formData.telephone = ''
              this.formData.wxNumber = ''
              this.formData.remark = ''
              this.isDisabled = true
              setTimeout(() => {
                this.isDisabled = false //点击一次时隔两秒后才能再次点击
              }, 2000)
            } else {
              this.isDisabled = true
              setTimeout(() => {
                this.isDisabled = false //点击一次时隔两秒后才能再次点击
              }, 2000)
              this.$message.error(res.message);
            }
          })
        }
      })
    },
    // 检查是否有安装摄像头
    isWebcam() {

    },
    // 获取配置信息
    getConfig() {
      let data = {
        systemId: 0, // 系统ID
        courseId: this.courseId, // 课程ID
        packagebagId: this.packagebagId // 包编号
      };
      getEntpCourseConfigCurrent(data).then(res => {
        // console.log(res, 'res');
        if (res.code == 200) {
          this.resData = res.data
          if (this.resData.needLimit == 1) {
            this.resData.limitClassHour = null
          }
          if (res.data == null) {
            this.courseConfig.canDrop = "on"
            this.courseConfig.completeRateFlag = 90
            this.getCourseBaseInfoCatalog();
          } else {
            this.courseConfig.completeRateFlag = res.data.videoRatio
            if (res.data.needPhoto == 0) {
              this.takePhotoCount = res.data.needPhotoCount
              this.getCourseBaseInfoCatalog();
            } else {
              this.getCourseBaseInfoCatalog();
            }
            if (res.data.canDrag == 1) {
              this.courseConfig.canDrop = "on"
            } else {
              this.courseConfig.canDrop = "off"
            }
            this.trialFlag = res.data.trialFlag
            this.trialDuration = res.data.trialDuration
            this.gatherInformationFlag = res.data.gatherInformationFlag
          }
        }
      })
    },
    //清除定时器
    clearFaTimer() {
      clearInterval(this.isWatch);
      this.interval = null;
      console.log("清除父组件定时器成功")
    },
    //获取目录和详情,调取播放器
    getCourseBaseInfoCatalog() {
      this.regId = localStorage.getItem("studyRegId");
      let data = {
        courseId: this.courseId,
        packagebagId: this.packagebagId,
        regId: this.regId
      };
      getUserCourseStudyDetail(data).then(res => {
        if (res.code == 200) {
          this.baseInfoCatalogList = res.data.courseCatalogList
          this.coursePic = res.data.coursePic
          this.courseName = res.data.courseName
          this.courseId = res.data.courseId
          if (this.playData.vid) {
            /**保利威替换 start */
            // this.vid = this.playData.vid;
            /**保利威替换 end */
            /**播放器 start */
            let $vid =  this.playData.vid
            /**播放器 end */
            this.liSelected = this.playData.liSelected
            if (!this.playData.courseDelayTime) {
              this.start = 0
            } else {
              this.start = this.playData.courseDelayTime
            }
            this.ccId = this.playData.ccId
            this.resouceHours = this.playData.resouceHours
            // this.autoPlay = true
            this.playerStart($vid); //播放器 此处加了一个入参
          } else {
            /**保利威替换 start */
            // this.vid = this.baseInfoCatalogList[0].cousecate[0].vid;
            /**保利威替换 end */
            /**播放器 start */
            let $vid = this.baseInfoCatalogList[0].cousecate[0].vid
            this.ccId = this.baseInfoCatalogList[0].ccId;
            // this.autoPlay = false
            this.playerStart() 

            $("#player").css("display", "none")
            $("#buylink").css("display", "none")
            $("#startScreen").css("display", "block")
          }
        }
      })
    },
    //播放器
    playerStart($vid) { //播放器 此处加了一个入参
      console.log($vid)
      let _this = this;
      // clearInterval(_this.timeOut);
      console.log('playerStart_wx')
      _this.isSave = false
      // console.log("播放器生产前历史参数", _this.start)
      // _this.player = polyvObject('#player').videoPlayer({
      //   'width': 'auto',
      //   'height': _this.playHeight,
      //   'list_id': 'id',
      //   'forceH5': true,
      //   'speed': false,
      //   'ignoreIE': true,
      //   'ban_seek': _this.courseConfig.canDrop, // 是否禁止视频拖拽未播放区域(进度条拖动)
      //   // "autoplay": _this.autoPlay,
      //   "autoplay": false,
      //   // "autoplay": true,
      //   "watchStartTime": _this.start,
      //   'flashvars': {
      //     'allowscriptaccess': "always",
      //     'allowNetworking': "all",
      //     "setScreen": "16_9",
      //   },
      //   'vid': _this.vid
      // })

      // this.player = polyvPlayer({
      //   wrap: '#player',
      //   'width': 'auto',
      //   'height': _this.playHeight,
      //   autoplay: false,
      //   vid: _this.vid,
      //   'speed': false,
      //   'ban_seek': _this.courseConfig.canDrop,
      //   "watchStartTime": _this.start || 0,
      //   // playsafe: 'c7cabb17-579c-42df-9e11-afc71ac6120b-c12678',
      //   // ts:'1649934545000',
      //   // sign:'de2234b62946998946275e2524696d59',
      //   // params:{'param2':'tony','param1':'1000',},
      // });
      /**播放器start */
      //调整到最后改变vid，播放器自动播放视频
      //在此之前，startTime（播放开始时间），
      //  dragEnable（是否可拖拽）先改变好
      if($vid){
        this.vid = $vid 
      }
      /**播放器end */

      console.log("打印播放器生成时各个属性", _this.player)
      if (_this.start > 0) {
        _this.oldPlayTime = _this.start
      } else {
        _this.oldPlayTime = 0
      }
      window.s2j_onVideoPlay = function () { //视频开始播放
        // console.log("视频开始播放")
        // _this.intervalid1 = setInterval(() => {
        //   if (_this.courseOver == 1) {
        //     _this.saveUserCourseStudingData(1)
        //   } else {
        //     _this.saveUserCourseStudingData(0)
        //   }
        // }, 120000);
        _this.getCourseCatalog();
        _this.interval = setInterval(_this.render, 1000)
      };
      window.s2j_onVideoPause = function () { 
        //视频暂停播放
        clearInterval(_this.intervalid1);
        clearInterval(_this.interval)
      };
      window.s2j_onPlayOver = function () { 
        //视频播放完成
        clearInterval(_this.intervalid1);
        clearInterval(_this.interval);
        _this.autoPlay = false;
        // _this.saveUserCourseStudingData(1);
        if (sessionStorage.getItem('courseIds')) {

        } else {
          _this.popupDialog = true;
        }
        $("#player").css("display", "none");
        $("#buylink").css("display", "block");
        $("#startScreen").css("display", "none");
        let parent = _this.liSelected.split("-")[0];
        let child = _this.liSelected.split("-")[1];
        _this.baseInfoCatalogList.map((item, index) => { //播放完成之后立马显示已经完成的图标
          if (index == parent) {
            let cousecate = item.cousecate;
            cousecate.map((temp, sub) => {
              if (sub == child) {
                temp.courseOver = 1
              }
            })
          }
        });
        setTimeout(function () {
          _this.getCourseCatalog()
        }, 500)
      }
    },
    ycyOnPlay(){
      console.log("ycyOnPlay")
      if(window.s2j_onVideoPlay){
        window.s2j_onVideoPlay()
      }
    },
    ycyOnPause(){
      console.log("ycyOnPause")
      if(window.s2j_onVideoPause){
        window.s2j_onVideoPause()
      }
    },
    ycyOnEnded(){
      console.log("ycyOnEnded")
      if(window.s2j_onPlayOver){
        window.s2j_onPlayOver()
      }
    },
    getEnterpriseWebsite() { 
      //根据域名获取企业id
      // var eUrl = window.location.href;
      // var eUrl = 'http://snyg.e.eceping.net';
      // var eUrl="http://www.eceping.net"
      //  var eUrl="http://hnpx.enterprise.eceping.net"
      var param = {
        entpWebsite: eUrl /*eUrl.substring(0,eUrl.indexOf(":",5))*/
      };
      getEnterpriseWebsite(param).then(res => {
        if (res.code == 200) {
          localStorage.setItem("enterpriseId", res.data.entpId)
          localStorage.setItem("entpCreditNo", res.data.entpCreditNo)
        }
      })
    },
    //获取目录和详情
    getCourseCatalog() {
      let data = {
        courseId: this.courseId,
        packagebagId: this.packagebagId,
        regId: this.regId
      }
      getUserCourseStudyDetail(data).then(res => {
        if (res.code == 200) {
          this.baseInfoCatalogList = res.data.courseCatalogList
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //选中某一条视频进行播放
    playVideo(
      vid, 
      ccId, 
      courseDelayTime, 
      index, 
      sub, 
      courseOver, 
      resouceHours, 
      trialFlag
      ) {
      // vid='8E90A7289B0871CF753C612EB38A8D5A'
      this.isPdf = false
      // this.trialFlag = trialFlag
      this.midTake = false;
      console.log(hasWebcam, isWebcamAlreadyCaptured, 888)
      // this.player.destroy();
      // console.log("打印历史播放时长", this.start)
      // console.log("打印所有播放参数", vid, ccId, courseDelayTime, index, sub, courseOver, resouceHours)
      if (!courseDelayTime) {
        courseDelayTime = 0
      }
      console.log("打印播放修改后参数", courseDelayTime)
      clearInterval(this.takePhotoInter)
      if (trialFlag == 1) {
        if (that.resData.limitClassHour) {
          let data = {}
          data.courseId = this.courseId
          getStudyccCountToday(data).then(ressssss => {
            if (ressssss.data >= that.resData.limitClassHour) {
              // console.log('111', ressssss.data >= that.resData.limitClassHour)
              if (courseOver == 1 || courseOver == 0) {
                that.playObj = {
                  vid: vid,
                  ccId: ccId,
                  courseDelayTime: courseDelayTime,
                  index: index,
                  sub: sub,
                  courseOver: courseOver,
                  resouceHours: resouceHours
                };
                /**保利威替换 start */
                // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
                /**保利威替换 end */
                that.resouceHours = resouceHours;
                $("#player").css("display", "block");
                $("#buylink").css("display", "none");
                $("#startScreen").css("display", "none");
                that.current = index;
                that.select = index + 's';
                /**保利威替换 start */
                // that.vid = vid;
                /**保利威替换 end */
                /**播放器 start */
                let $vid = vid
                /**播放器 end */
                that.ccId = ccId;
                that.start = courseDelayTime;
                that.autoPlay = true;
                that.liSelected = index + "-" + sub;
                that.courseOver = courseOver;
                that.playerStart($vid); //播放器 此处加了一个入参
              } else {
                this.$message({
                  message: '当日可学习课时已学完，请明日在进行学习',
                  type: 'warning',
                  duration: '2000',
                })
                clearInterval(that.isWatch);
              }

            } else {
              that.playObj = {
                vid: vid,
                ccId: ccId,
                courseDelayTime: courseDelayTime,
                index: index,
                sub: sub,
                courseOver: courseOver,
                resouceHours: resouceHours
              };
              let allSS = resouceHours.slice(0, 2) * 1 * 60 * 60 * 1000 + resouceHours.slice(3, 5) * 1 * 60 * 1000
              that.takePhotoTime = allSS / that.takePhotoCount
              /**保利威替换 start */
              // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
              /**保利威替换 end */
              that.resouceHours = resouceHours;
              $("#player").css("display", "block");
              $("#buylink").css("display", "none");
              $("#startScreen").css("display", "none");
              that.current = index;
              that.select = index + 's';
              /**保利威替换 start */
              // that.vid = vid;
              /**保利威替换 end */
              /**播放器 start */
              let $vid = vid
              /**播放器 end */
              that.ccId = ccId;
              that.start = courseDelayTime;
              that.autoPlay = true;
              that.liSelected = index + "-" + sub;
              that.courseOver = courseOver;
              that.playerStart($vid); //播放器 此处加了一个入参
              // that.takePhotoInter = setInterval(function () {
              //   if (that.courseConfig.camera) {
              //     that.dialogTableVisible = true
              //     that.player.j2s_pauseVideo();
              //   }
              // }, 500)
            }
          })
        } else {
          that.playObj = {
            vid: vid,
            ccId: ccId,
            courseDelayTime: courseDelayTime,
            index: index,
            sub: sub,
            courseOver: courseOver,
            resouceHours: resouceHours
          };
          let allSS = resouceHours.slice(0, 2) * 1 * 60 * 60 * 1000 + resouceHours.slice(3, 5) * 1 * 60 * 1000
          that.takePhotoTime = allSS / that.takePhotoCount
          /**保利威替换 start */
          // that.player.destroy(); // 销毁播放器，包括HTML5和flash播放器
          /**保利威替换 end */
          that.resouceHours = resouceHours;
          $("#player").css("display", "block");
          $("#buylink").css("display", "none");
          $("#startScreen").css("display", "none");
          that.current = index;
          that.select = index + 's';
          /**保利威替换 start */
          // that.vid = vid;
          /**保利威替换 end */
          /**播放器 start */
          let $vid = vid
          /**播放器 end */
          that.ccId = ccId;
          that.start = courseDelayTime;
          that.autoPlay = true;
          that.liSelected = index + "-" + sub;
          that.courseOver = courseOver;
          that.playerStart($vid); //播放器 此处加了一个入参
          // that.takePhotoInter = setInterval(function () {
          //   if (that.courseConfig.camera) {
          //     that.dialogTableVisible = true
          //     that.player.j2s_pauseVideo();
          //   }
          // }, 500)
        }
      } else {
        this.$message({
          message: '请购买该课程进行学习',
          type: 'warning',
          duration: '2000',
        })
      }
    },
    // 普通课件下载
    linkOpenPage(vid, ccId, courseDelayTime, index, sub, courseOver, resouceHours, trialFlag,coursewareUrl,ccName) {
      if (trialFlag == 1) {
      if(coursewareUrl !=null){
        const extension = coursewareUrl.substring(coursewareUrl.lastIndexOf('.') + 1).toLowerCase();
        if(extension =='pdf'){
          this.isPdf = true
          this.pdfLink = coursewareUrl
        }else if(extension =='txt'){
          let strData = new Blob([coursewareUrl], { type: 'text/plain;charset=utf-8' });
          saveAs(strData,ccName);
        }else{
          window.open(coursewareUrl)
          }
        }
      } else {
        this.$message({
          message: '请购买该课程进行学习',
          type: 'warning',
          duration: '2000',
        })
      }
    },
    //播放器的记时功能
    render() {
      if (

        /**保利威替换 start */
        // this.player != undefined &&
        // this.player.j2s_getCurrentTime != undefined
        /**保利威替换 end */
        /**播放器 start */
        this.$refs.ycyPlayer != undefined && 
        this.$refs.ycyPlayer.getCurrentTime != undefined
        /**播放器 end */
        ) {
        /**保利威替换 start */
        // this.playTime = this.player.j2s_getCurrentTime();
        /**保利威替换 end */
        /**播放器 start */
        this.playTime = this.$refs.ycyPlayer.getCurrentTime();
        /**播放器 end */
        this.oldPlayTime = this.playTime;
        // let midTime = Math.ceil(this.player.j2s_getDuration() / 2)
        // console.log(999, midTime, Math.ceil(this.playTime))
        if (this.playTime >= this.trialDuration * 60) {
          if (this.gatherInformationFlag == 1) {
            let courseList = []
            courseList = sessionStorage.getItem('courseIds') ? sessionStorage.getItem('courseIds').split(',') : sessionStorage.getItem('courseIds')
            if (courseList) {
              courseList.map(item => {
                // console.log('11111', this.courseId == item)
                if (this.courseId == item) {
                  this.$message({
                    message: '若要获取完整体验课程，请等待工作人员联系您！',
                    type: 'warning',
                    duration: '2000',
                  })
                  /**保利威替换 start */
                  // that.player.j2s_pauseVideo();
                  /**保利威替换 end */
                  /**播放器 start */
                  that.$refs.ycyPlayer.pause();
                  /**播放器 end */
                } else {
                  this.popupDialog = true;
                }
              })
            } else {
              this.popupDialog = true;
            }
          } else {
            this.popupDialog = false;
          }
          /**保利威替换 start */
          // that.player.j2s_pauseVideo();
          /**保利威替换 end */
          /**播放器 start */
          that.$refs.ycyPlayer.pause();
          /**播放器 end */
        }
        let trialFlag = ''
        if (this.playData && this.trialFlag == null) {
          trialFlag = this.playData.trialFlag
        } else {
          trialFlag = this.trialFlag
        }
        //   if (that.courseConfig.completeRateFlag && that.courseConfig.completeRateFlag != '') {
        //     let resouceHours = this.timeToSec(this.resouceHours) * (new Number(that.courseConfig.completeRateFlag) / 100);
        //     if (this.playTime >= resouceHours) { //根据配置来
        //       if (!this.isSave) {
        //         console.log("百分比数据层生效")
        //         this.saveUserCourseStudingData(1)
        //       }
        //     }
        //   } else {
        //     let resouceHours = this.timeToSec(this.resouceHours) - 60;
        //     if (this.playTime >= resouceHours) { //还剩1分钟时调用接口
        //       if (!this.isSave) {
        //         this.saveUserCourseStudingData(1)
        //       }
        //     }
        //   }
      }
    },
    //伸缩章节
    pulling(cataLog, event) {
      var el = event.currentTarget
      let idName = "#" + cataLog
      let ispull = $(idName).attr('ispull')
      if (ispull == 'true') {
        $(idName).removeClass("show")
        $(idName).attr('ispull', 'false')
        $(el).find(".up").hide()
        $(el).find(".down").show()
      } else {
        $(idName).addClass("show")
        $(idName).attr('ispull', 'true')
        $(el).find(".down").hide()
        $(el).find(".up").show()
      }
    },
    //获取屏幕高度
    getScreenHeight() {
      var clientHeight = document.documentElement.clientHeight
      var clientWidth = document.documentElement.clientWidth
      // console.log("可视高度",clientHeight,"可视宽度",clientWidth)
      this.playHeight = (clientHeight - 60)
      // console.log(this.playHeight)
      $("#videoPlay").height(this.playHeight)
      $("#playerBox").height(this.playHeight)
      $("#player").height(this.playHeight-20)
      $("#videoList").height(this.playHeight)
      $("#videoBox").height(this.playHeight)
      $("#buylink").height(this.playHeight)
      $("#startScreen").height(this.playHeight)
      $("#pdfShowStyle").height(this.playHeight-20)
    },
    //路由回退
    goBack() {
      sessionStorage.setItem("coursePlayGoBack", 1)
      this.$router.replace({
        path: "/courseDetail",
        name: "courseDetail",
        params: {
          courseId: this.courseId,
          packagebagId: this.packagebagId
        }
      })
      // 返回上一页后  当前页面关闭摄像头
    },

    //将时分秒转换成秒
    timeToSec(time) {
      // console.log(time, 'time');
      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(sec)
      return s
    },

    // 访问用户媒体设备
    getUserMedia(constrains, success, error) {
      if (!navigator.mediaDevices) {
        error({
          name: '环境错误',
          message: "请确定是否处于https协议环境下"
        })
        return;
      }
      if (navigator.mediaDevices.getUserMedia) {
        //最新标准API
        navigator.mediaDevices
          .getUserMedia(constrains)
          .then(success)
          .catch(error);
      } else if (navigator.webkitGetUserMedia) {
        //webkit内核浏览器
        navigator.webkitGetUserMedia(constrains).then(success).catch(error);
      } else if (navigator.mozGetUserMedia) {
        //Firefox浏览器
        navagator.mozGetUserMedia(constrains).then(success).catch(error);
      } else if (navigator.getUserMedia) {
        //旧版API
        navigator.getUserMedia(constrains).then(success).catch(error);
      } else {
        error({
          name: '兼容异常',
          message: "你的浏览器不支持访问用户媒体设备"
        })
        // this.mediaMessage = "你的浏览器不支持访问用户媒体设备";
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/coursePlayNew/coursePlay.js